import React, { Component } from 'react';


import { Tooltip, Button, Row, notification, Popconfirm, Switch,Tag,Badge } from 'antd';
import { RESTExecutor,withDomains } from '../../lib/domain';
import { showErrorInNotification } from '../../lib/util';
import ManualReconcilerList from './manual_reconciler_list';
import { COLORS } from '../theme';
import { TransparentButton } from '../../components/basic_items';
import { PlaylistAddCheckOutlined } from '@material-ui/icons';


export const OURS_KEY = 'ours';
export const THEIRS_KEY = 'theirs'

class ManualMode extends Component {
    constructor(props) {
        super(props)
    
        this.state = {
            // supports manual or recommended or tabular
            reconciler_mode: 'Manual',
            loading: true,
            recommend_for: OURS_KEY,
            selected_our: null,
            selected_our_index: null,
            selected_rule:{},
            selected_their: null,
            selected_their_index: null,
            selected_our_transaction:{},
            selected_their_transaction:{}
          };

          this.reconcile_manually = RESTExecutor.post().config({
            label: 'reconcile_manually'
          }).forId(this.props.reconciler_id).callbacks((success) => {
            console.log("success", success)
            if (this.state.reconciler_mode === 'Manual') {
              console.log("recon mode manual",this.our_manual,this.their_manual);
              console.log(this)
              if (this.our_manual) {
                try {
                  // this.our_manual.resetAndRefresh();
                  this.our_manual.removeWithIndex(this.state.selected_our_index,this.state.selected_their)
                } catch (e) {
      
                }
              }
              if (this.their_manual) {
                try {
                  // this.their_manual.resetAndRefresh();
                  this.their_manual.removeWithIndex(this.state.selected_their_index,this.state.selected_our)
                } catch (e) {
                }
              }
      
            } 
            // FOR RECOMMENDED
            else {
              if (this.our_manual) {
                try {
                  this.our_manual.resetAndRefresh();
                } catch (e) {
      
                }
              }
              if (this.recommen_list) {
                try {
                  this.recommen_list.getRecommendation(null);
                } catch (e) {
                }
              }
            }
            this.setState({
              selected_our: null,
              selected_their: null,
              selected_our_index:null,
              selected_their_index:null,
              selected_our_transaction:{},
              selected_their_transaction:{}
            });

            notification.success({
                message:"Reconciled Transaction",
                description:""
            })
          }, (error) => {
            showErrorInNotification(error);
          }).connect(props.domains.reconciliation);
    }
    
  render() {
    const { reconciler_mode, loading, recommend_for, selected_our, selected_their ,selected_rule,selected_our_transaction,selected_their_transaction} = this.state;
    let reconciler_id=this.props.reconciler_id;
    let reconcile_manually_resp = this.reconcile_manually.response();

    let reconciler=this.props.reconciler||{};
    let references=reconciler.__references__||{};
    let  our_datatype=references.our_data_type_id||{};
    let their_datatype=references.their_data_type_id||{};

    let manual_rules=reconciler.manual_rules||{}
    let current_mode=this.props.currentMode;

    return (
        <React.Fragment>
        <Row type='flex' justify='space-between' style={{ flexWrap: 'nowrap', overflowX:'scroll',minWidth:900,flex:1}}>

        <ManualReconcilerList
          mode={this.props.mode}
          onModeChange={this.props.onModeChange}
          type={OURS_KEY}
          reconcile_btn={(selected_our && selected_their)&& <Popconfirm
            title={<div>
              <label>{`Amount ${selected_our_transaction&&selected_our_transaction.amount} not equal to ${selected_their_transaction&&selected_their_transaction.amount}. Do you want to reconcile?`}</label>
            </div>}
          disabled={! (manual_rules.amount_equal && (selected_our_transaction&&selected_our_transaction.amount&&selected_their_transaction&&selected_their_transaction.amount&&selected_our_transaction.amount!=selected_their_transaction.amount)) }
          onConfirm={()=>{
              this.reconcile_manually.forId(this.props.reconciler_id).execute({
                  our_id: String(selected_our),
                  their_id: String(selected_their),
                  source_id:this.props.source_id
                });
          }}
          >
            <TransparentButton
              disabled={!(selected_our && selected_their) || reconcile_manually_resp.fetching}
              className='cta-reconcile'
                onClick={()=>{
                  if(!(manual_rules.amount_equal && (selected_our_transaction&&selected_our_transaction.amount&&selected_their_transaction&&selected_their_transaction.amount&&selected_our_transaction.amount!=selected_their_transaction.amount))){
                    this.reconcile_manually.forId(this.props.reconciler_id).execute({
                        our_id: String(selected_our),
                        their_id: String(selected_their),
                        source_id:this.props.source_id
                      });
                  }
                }}
                icon={<PlaylistAddCheckOutlined/>}
                label="RECONCILE"
                />
          </Popconfirm>}
          toggleRender={<React.Fragment>
            <span className='sub-heading-3'>{"OURS"}</span>
            &nbsp;&nbsp;&nbsp;
            <span className='heading-2' style={{
              color:COLORS.primary
            }}>{our_datatype.name}</span>
            &nbsp;&nbsp;&nbsp;
            {/* <SyncAltRounded 
            onClick={()=>{
              this.setState({
                recommend_for: recommend_for === OURS_KEY ? THEIRS_KEY : OURS_KEY,
                selected_our: null,
                selected_their: null,
                selected_our_transaction:{},
                selected_their_transaction:{}
              })
            }}
            titleAccess="Switch OURS and THEIRS" 
            className='toggle-icon hand-cursor' /> */}
            </React.Fragment>}
          reconciler_id={this.props.reconciler_id}
          source_id={this.props.source_id}
          reconciler={this.props.reconciler}
          key={`${reconciler_mode}our`}
          onSelectedID={(id,data,index) => {
            this.setState({
              selected_our: id,
              selected_our_transaction:data,
              selected_our_index:index
            })
          }}
          onRef={(ref) => {
            console.log("manual our", ref)
            this.our_manual = ref
          }}
        />
        <div style={{width:30}}></div>

        <ManualReconcilerList
          currentMode={this.props.currentMode}
          onToggle={this.props.onToggle}
          reconcile_btn={(selected_our && selected_their)&& <Popconfirm
            title={<div>
              <label>{`Amount ${selected_our_transaction&&selected_our_transaction.amount} not equal to ${selected_their_transaction&&selected_their_transaction.amount}. Do you want to reconcile?`}</label>
            </div>}
          disabled={! (manual_rules.amount_equal && (selected_our_transaction&&selected_our_transaction.amount&&selected_their_transaction&&selected_their_transaction.amount&&selected_our_transaction.amount!=selected_their_transaction.amount)) }
          onConfirm={()=>{
              this.reconcile_manually.forId(this.props.reconciler_id).execute({
                  our_id: String(selected_our),
                  their_id: String(selected_their),
                  source_id:this.props.source_id
                });
          }}
          >
            <TransparentButton
              disabled={!(selected_our && selected_their) || reconcile_manually_resp.fetching}
              className='cta-reconcile'
                onClick={()=>{
                  if(!(manual_rules.amount_equal && (selected_our_transaction&&selected_our_transaction.amount&&selected_their_transaction&&selected_their_transaction.amount&&selected_our_transaction.amount!=selected_their_transaction.amount))){
                    this.reconcile_manually.forId(this.props.reconciler_id).execute({
                        our_id: String(selected_our),
                        their_id: String(selected_their),
                        source_id:this.props.source_id
                      });
                  }
                }}
                icon={<PlaylistAddCheckOutlined/>}
                label="RECONCILE"
                />
          </Popconfirm>}
          toggleRender={<React.Fragment>
            <span className='sub-heading-3'>{"THEIRS"}</span>
            &nbsp;&nbsp;&nbsp;
            <span className='heading-2' style={{
              color:COLORS.primary
            }}>{their_datatype.name}</span>
            &nbsp;&nbsp;&nbsp;
            {/* <SyncAltRounded 
            onClick={()=>{
              this.setState({
                recommend_for: recommend_for === OURS_KEY ? THEIRS_KEY : OURS_KEY,
                selected_our: null,
                selected_their: null,
                selected_our_transaction:{},
                selected_their_transaction:{}
              })
            }}
            titleAccess="Switch OURS and THEIRS" 
            className='toggle-icon hand-cursor' /> */}
            </React.Fragment>}
          key={`${reconciler_mode}their`}
          type={THEIRS_KEY}
          reconciler_id={this.props.reconciler_id}
          source_id={this.props.source_id}
          reconciler={this.props.reconciler}
          onSelectedID={(id,data,index) => {
            this.setState({
              selected_their: id,
              selected_their_transaction:data,
              selected_their_index:index
            })
          }}
          onRef={(ref) => {
            console.log("manual their", ref)
            this.their_manual = ref
          }}
        />
        </Row>
      </React.Fragment>
    );
  }
}

export default  withDomains(ManualMode,"reconciliation");
